

















import Vue from 'vue';
import Cookies from 'js-cookie';


export default Vue.extend({
  name: 'FederatedLogOut',
  mounted() {
      Cookies.remove('federatedSignIn');
  },
});
